import type { NavIcon } from '../lib/navigation'

interface SidebarIconProps {
  name: NavIcon
  size?: number
  color?: string
}

/**
 * Familia unica de icones: traco de 1.6px, viewBox 24, sem preenchimento.
 * Todos os itens de primeiro nivel usam o mesmo tamanho (16px por padrao).
 */
export default function SidebarIcon({ name, size = 16, color = 'currentColor' }: SidebarIconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: 'false' as const,
    style: { flexShrink: 0, display: 'block' as const },
  }

  switch (name) {
    case 'dashboard':
      return (
        <svg {...common}>
          <rect x="3" y="3" width="7.5" height="7.5" rx="1.6" />
          <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.6" />
          <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.6" />
          <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.6" />
        </svg>
      )
    case 'budget':
      return (
        <svg {...common}>
          <path d="M12 3 3 7.8l9 4.8 9-4.8L12 3Z" />
          <path d="M3 12.6 12 17.4l9-4.8" />
          <path d="M3 17.2 12 22l9-4.8" />
        </svg>
      )
    case 'supply':
      return (
        <svg {...common}>
          <path d="M2.5 3.5h2.2l2.4 11.3a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7.8H6" />
          <circle cx="9.5" cy="20" r="1.4" />
          <circle cx="17.5" cy="20" r="1.4" />
        </svg>
      )
    case 'finance':
      return (
        <svg {...common}>
          <rect x="2.5" y="6" width="19" height="12" rx="2" />
          <circle cx="12" cy="12" r="2.6" />
          <path d="M6 12h.01M18 12h.01" />
        </svg>
      )
    case 'workflow':
      return (
        <svg {...common}>
          <path d="M9 11.2 12 14.2 20 6.2" />
          <path d="M20.5 12.5v5.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h9" />
        </svg>
      )
    case 'registry':
      return (
        <svg {...common}>
          <path d="M3 7.2a2 2 0 0 1 2-2h3.6l2 2H19a2 2 0 0 1 2 2v8.6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.2Z" />
          <path d="M3 11h18" />
        </svg>
      )
    case 'settings':
      return (
        <svg {...common}>
          <path d="M3.5 7.5h8M17 7.5h3.5M3.5 16.5h3.5M12.5 16.5h8" />
          <circle cx="14.2" cy="7.5" r="2.4" />
          <circle cx="9.7" cy="16.5" r="2.4" />
        </svg>
      )
    default:
      return null
  }
}

/** Seta de expansao usada em todos os grupos, com a mesma rotacao. */
export function ChevronIcon({ open, size = 12, color = 'currentColor' }: { open: boolean; size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      style={{
        flexShrink: 0,
        display: 'block',
        transition: 'transform 0.16s ease',
        transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
      }}
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  )
}
